/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../../app/shared/components/extra-fields-list/item/extra-fields-list.item.component';
const styles_ExtraFieldsListItemComponent:any[] = ([] as any[]);
export const RenderType_ExtraFieldsListItemComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ExtraFieldsListItemComponent,data:{}});
function View_ExtraFieldsListItemComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),5,'input',[['class',
      'form-control'],['type','text']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'blur'],[(null as any),'input'],[(null as any),
      'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,1)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,1).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i0.ɵnov(_v,1)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i0.ɵnov(_v,1)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('blur' === en)) {
      const pd_4:any = ((<any>_co.onFieldChange(_co.extraField.slug)) !== false);
      ad = (pd_4 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,16384,(null as any),0,i1.DefaultValueAccessor,
      [i0.Renderer2,i0.ElementRef,[2,i1.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i0.ɵprd(1024,(null as any),i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i1.DefaultValueAccessor]),i0.ɵdid(3,671744,(null as any),0,i1.FormControlName,
          [[3,i1.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {name:[0,'name']},(null as any)),i0.ɵprd(2048,(null as any),i1.NgControl,
          (null as any),[i1.FormControlName]),i0.ɵdid(5,16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = i0.ɵinlineInterpolate(1,'',_co.extraField.slug,'');
    _ck(_v,3,0,currVal_7);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,5).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,5).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,5).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,5).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,5).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,5).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,5).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ExtraFieldsListItemComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),6,'input',[['class',
      'form-control'],['type','radio']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'blur'],[(null as any),'input'],[(null as any),
      'compositionstart'],[(null as any),'compositionend'],[(null as any),'change']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,1)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('change' === en)) {
          const pd_4:any = ((<any>i0.ɵnov(_v,2).onChange()) !== false);
          ad = (pd_4 && ad);
        }
        if (('blur' === en)) {
          const pd_5:any = ((<any>i0.ɵnov(_v,2).onTouched()) !== false);
          ad = (pd_5 && ad);
        }
        if (('blur' === en)) {
          const pd_6:any = ((<any>_co.onFieldChange(_co.extraField.slug)) !== false);
          ad = (pd_6 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(1,16384,(null as any),0,i1.DefaultValueAccessor,
      [i0.Renderer2,i0.ElementRef,[2,i1.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i0.ɵdid(2,212992,(null as any),0,i1.RadioControlValueAccessor,[i0.Renderer2,
          i0.ElementRef,i1.ɵi,i0.Injector],{formControlName:[0,'formControlName']},
          (null as any)),i0.ɵprd(1024,(null as any),i1.NG_VALUE_ACCESSOR,(p0_0:any,
          p1_0:any) => {
        return [p0_0,p1_0];
      },[i1.DefaultValueAccessor,i1.RadioControlValueAccessor]),i0.ɵdid(4,671744,(null as any),
          0,i1.FormControlName,[[3,i1.ControlContainer],[8,(null as any)],[8,(null as any)],
              [2,i1.NG_VALUE_ACCESSOR]],{name:[0,'name']},(null as any)),i0.ɵprd(2048,
          (null as any),i1.NgControl,(null as any),[i1.FormControlName]),i0.ɵdid(6,
          16384,(null as any),0,i1.NgControlStatus,[i1.NgControl],(null as any),(null as any))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_7:any = i0.ɵinlineInterpolate(1,'',_co.extraField.slug,'');
        _ck(_v,2,0,currVal_7);
        const currVal_8:any = i0.ɵinlineInterpolate(1,'',_co.extraField.slug,'');
        _ck(_v,4,0,currVal_8);
      },(_ck,_v) => {
        const currVal_0:any = i0.ɵnov(_v,6).ngClassUntouched;
        const currVal_1:any = i0.ɵnov(_v,6).ngClassTouched;
        const currVal_2:any = i0.ɵnov(_v,6).ngClassPristine;
        const currVal_3:any = i0.ɵnov(_v,6).ngClassDirty;
        const currVal_4:any = i0.ɵnov(_v,6).ngClassValid;
        const currVal_5:any = i0.ɵnov(_v,6).ngClassInvalid;
        const currVal_6:any = i0.ɵnov(_v,6).ngClassPending;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
      });
}
function View_ExtraFieldsListItemComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),5,'input',[['class',
      'form-control'],['type','checkbox']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'blur'],[(null as any),'change']],(_v,en,
      $event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('change' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,1).onChange($event.target.checked)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,1).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('blur' === en)) {
      const pd_2:any = ((<any>_co.onFieldChange(_co.extraField.slug)) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,16384,(null as any),0,i1.CheckboxControlValueAccessor,
      [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
      i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i1.CheckboxControlValueAccessor]),i0.ɵdid(3,671744,(null as any),0,i1.FormControlName,
      [[3,i1.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
      {name:[0,'name']},(null as any)),i0.ɵprd(2048,(null as any),i1.NgControl,(null as any),
      [i1.FormControlName]),i0.ɵdid(5,16384,(null as any),0,i1.NgControlStatus,[i1.NgControl],
      (null as any),(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = i0.ɵinlineInterpolate(1,'',_co.extraField.slug,'');
    _ck(_v,3,0,currVal_7);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,5).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,5).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,5).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,5).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,5).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,5).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,5).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ExtraFieldsListItemComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),6,'input',[['class',
      'form-control'],['type','number']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'blur'],[(null as any),'input'],[(null as any),
      'compositionstart'],[(null as any),'compositionend'],[(null as any),'change']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,1)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('change' === en)) {
          const pd_4:any = ((<any>i0.ɵnov(_v,2).onChange($event.target.value)) !== false);
          ad = (pd_4 && ad);
        }
        if (('input' === en)) {
          const pd_5:any = ((<any>i0.ɵnov(_v,2).onChange($event.target.value)) !== false);
          ad = (pd_5 && ad);
        }
        if (('blur' === en)) {
          const pd_6:any = ((<any>i0.ɵnov(_v,2).onTouched()) !== false);
          ad = (pd_6 && ad);
        }
        if (('blur' === en)) {
          const pd_7:any = ((<any>_co.onFieldChange(_co.extraField.slug)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(1,16384,(null as any),0,i1.DefaultValueAccessor,
      [i0.Renderer2,i0.ElementRef,[2,i1.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i0.ɵdid(2,16384,(null as any),0,i1.ɵbc,[i0.Renderer2,i0.ElementRef],(null as any),
          (null as any)),i0.ɵprd(1024,(null as any),i1.NG_VALUE_ACCESSOR,(p0_0:any,
          p1_0:any) => {
        return [p0_0,p1_0];
      },[i1.DefaultValueAccessor,i1.ɵbc]),i0.ɵdid(4,671744,(null as any),0,i1.FormControlName,
          [[3,i1.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {name:[0,'name']},(null as any)),i0.ɵprd(2048,(null as any),i1.NgControl,
          (null as any),[i1.FormControlName]),i0.ɵdid(6,16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = i0.ɵinlineInterpolate(1,'',_co.extraField.slug,'');
    _ck(_v,4,0,currVal_7);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,6).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,6).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,6).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,6).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,6).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,6).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,6).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ExtraFieldsListItemComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),5,'textarea',[['class',
      'form-control'],['rows','3']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'blur'],[(null as any),'input'],[(null as any),
      'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,1)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,1).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i0.ɵnov(_v,1)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i0.ɵnov(_v,1)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('blur' === en)) {
      const pd_4:any = ((<any>_co.onFieldChange(_co.extraField.slug)) !== false);
      ad = (pd_4 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,16384,(null as any),0,i1.DefaultValueAccessor,
      [i0.Renderer2,i0.ElementRef,[2,i1.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i0.ɵprd(1024,(null as any),i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i1.DefaultValueAccessor]),i0.ɵdid(3,671744,(null as any),0,i1.FormControlName,
          [[3,i1.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {name:[0,'name']},(null as any)),i0.ɵprd(2048,(null as any),i1.NgControl,
          (null as any),[i1.FormControlName]),i0.ɵdid(5,16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = i0.ɵinlineInterpolate(1,'',_co.extraField.slug,'');
    _ck(_v,3,0,currVal_7);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,5).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,5).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,5).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,5).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,5).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,5).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,5).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ExtraFieldsListItemComponent_7(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'option',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(1,
      147456,(null as any),0,i1.NgSelectOption,[i0.ElementRef,i0.Renderer2,[8,(null as any)]],
      {value:[0,'value']},(null as any)),i0.ɵdid(2,147456,(null as any),0,i1.ɵq,[i0.ElementRef,
      i0.Renderer2,[2,i1.SelectMultipleControlValueAccessor]],{value:[0,'value']},
      (null as any)),(_l()(),i0.ɵted(3,(null as any),['','']))],(_ck,_v) => {
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = i0.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit.label;
    _ck(_v,3,0,currVal_2);
  });
}
function View_ExtraFieldsListItemComponent_6(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),9,'select',[['class',
      'multiple-select form-control']],[[8,'multiple',0],[2,'ng-untouched',(null as any)],
      [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
          (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
      [2,'ng-pending',(null as any)]],[[(null as any),'blur'],[(null as any),'change']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onChange($event.target)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('blur' === en)) {
          const pd_2:any = ((<any>_co.onFieldChange(_co.extraField.slug)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(1,16384,(null as any),0,i1.SelectMultipleControlValueAccessor,
      [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
      i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i1.SelectMultipleControlValueAccessor]),i0.ɵdid(3,671744,(null as any),0,
      i1.FormControlName,[[3,i1.ControlContainer],[8,(null as any)],[8,(null as any)],
          [2,i1.NG_VALUE_ACCESSOR]],{name:[0,'name']},(null as any)),i0.ɵprd(2048,
      (null as any),i1.NgControl,(null as any),[i1.FormControlName]),i0.ɵdid(5,16384,
      (null as any),0,i1.NgControlStatus,[i1.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n                '])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ExtraFieldsListItemComponent_7)),
      i0.ɵdid(8,802816,(null as any),0,i2.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted(-1,
          (null as any),['\n            ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_8:any = i0.ɵinlineInterpolate(1,'',_co.extraField.slug,'');
    _ck(_v,3,0,currVal_8);
    const currVal_9:any = _co.extraField.options;
    _ck(_v,8,0,currVal_9);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.extraField.extra_field_type.multiple,
        '');
    const currVal_1:any = i0.ɵnov(_v,5).ngClassUntouched;
    const currVal_2:any = i0.ɵnov(_v,5).ngClassTouched;
    const currVal_3:any = i0.ɵnov(_v,5).ngClassPristine;
    const currVal_4:any = i0.ɵnov(_v,5).ngClassDirty;
    const currVal_5:any = i0.ɵnov(_v,5).ngClassValid;
    const currVal_6:any = i0.ɵnov(_v,5).ngClassInvalid;
    const currVal_7:any = i0.ɵnov(_v,5).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
  });
}
export function View_ExtraFieldsListItemComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),35,'div',[['class',
      'row']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,
      'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
      [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
      'submit'],[(null as any),'reset']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,1).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,1).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,540672,(null as any),0,i1.FormGroupDirective,
      [[8,(null as any)],[8,(null as any)]],{form:[0,'form']},(null as any)),i0.ɵprd(2048,
      (null as any),i1.ControlContainer,(null as any),[i1.FormGroupDirective]),i0.ɵdid(3,
      16384,(null as any),0,i1.NgControlStatusGroup,[i1.ControlContainer],(null as any),
      (null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(5,
      0,(null as any),(null as any),29,'div',[['class','col-md-12 col-12 form-group']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵeld(7,0,(null as any),
      (null as any),1,'label',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(8,(null as any),['',''])),(_l()(),
      i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵeld(10,0,(null as any),
      (null as any),20,'div',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),i0.ɵdid(11,16384,(null as any),0,i2.NgSwitch,([] as any[]),
      {ngSwitch:[0,'ngSwitch']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ExtraFieldsListItemComponent_1)),
      i0.ɵdid(14,278528,(null as any),0,i2.NgSwitchCase,[i0.ViewContainerRef,i0.TemplateRef,
          i2.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),i0.ɵted(-1,
          (null as any),['\n\n            '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ExtraFieldsListItemComponent_2)),i0.ɵdid(17,
          278528,(null as any),0,i2.NgSwitchCase,[i0.ViewContainerRef,i0.TemplateRef,
              i2.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),
          i0.ɵted(-1,(null as any),['\n\n            '])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ExtraFieldsListItemComponent_3)),
      i0.ɵdid(20,278528,(null as any),0,i2.NgSwitchCase,[i0.ViewContainerRef,i0.TemplateRef,
          i2.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),i0.ɵted(-1,
          (null as any),['\n\n            '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ExtraFieldsListItemComponent_4)),i0.ɵdid(23,
          278528,(null as any),0,i2.NgSwitchCase,[i0.ViewContainerRef,i0.TemplateRef,
              i2.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),
          i0.ɵted(-1,(null as any),['\n\n            '])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ExtraFieldsListItemComponent_5)),
      i0.ɵdid(26,278528,(null as any),0,i2.NgSwitchCase,[i0.ViewContainerRef,i0.TemplateRef,
          i2.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),i0.ɵted(-1,
          (null as any),['\n\n            '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ExtraFieldsListItemComponent_6)),i0.ɵdid(29,
          278528,(null as any),0,i2.NgSwitchCase,[i0.ViewContainerRef,i0.TemplateRef,
              i2.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),
          i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i0.ɵeld(32,0,(null as any),(null as any),1,'p',
          [['class','form-help']],[[8,'hidden',0]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted(33,(null as any),['\n            ','\n        '])),
      (_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.ExtraFieldsListItemComponent = _v.component;
    const currVal_7:any = _co.extraFieldsForm;
    _ck(_v,1,0,currVal_7);
    const currVal_9:any = _co.extraField.extra_field_type.type;
    _ck(_v,11,0,currVal_9);
    const currVal_10:any = 'text';
    _ck(_v,14,0,currVal_10);
    const currVal_11:any = 'radio';
    _ck(_v,17,0,currVal_11);
    const currVal_12:any = 'checkbox';
    _ck(_v,20,0,currVal_12);
    const currVal_13:any = 'number';
    _ck(_v,23,0,currVal_13);
    const currVal_14:any = 'textarea';
    _ck(_v,26,0,currVal_14);
    const currVal_15:any = 'select';
    _ck(_v,29,0,currVal_15);
  },(_ck,_v) => {
    var _co:i3.ExtraFieldsListItemComponent = _v.component;
    const currVal_0:any = i0.ɵnov(_v,3).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,3).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,3).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,3).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,3).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,3).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,3).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = _co.extraField.label;
    _ck(_v,8,0,currVal_8);
    const currVal_16:boolean = (!_co.validation.hasError(_co.extraField.slug) || _co.extraFieldsForm.controls[_co.extraField.slug].pristine);
    _ck(_v,32,0,currVal_16);
    const currVal_17:any = _co.validation.getError(_co.extraField.slug);
    _ck(_v,33,0,currVal_17);
  });
}
export function View_ExtraFieldsListItemComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'extra-fields-list-item',
      ([] as any[]),(null as any),(null as any),(null as any),View_ExtraFieldsListItemComponent_0,
      RenderType_ExtraFieldsListItemComponent)),i0.ɵdid(1,49152,(null as any),0,i3.ExtraFieldsListItemComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const ExtraFieldsListItemComponentNgFactory:i0.ComponentFactory<i3.ExtraFieldsListItemComponent> = i0.ɵccf('extra-fields-list-item',
    i3.ExtraFieldsListItemComponent,View_ExtraFieldsListItemComponent_Host_0,{extraField:'extraField',
        extraFieldsForm:'extraFieldsForm',validation:'validation'},{extraFieldChanged:'extraFieldChanged'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/$$_gendir/app/shared/components/extra-fields-list/item/extra-fields-list.item.component.ngfactory.ts